<template>
  <div class="trainingForm ml-4 mt-2 mb-1 mr-1">
    <div class="row ml-4 mr-4">   <div class="ml-4 mt-2 mb-1 mr-1">
      <b-card class="card-personalizada" header-tag="header" footer-tag="footer">
        <template #header>
          <h4 class="mb-0"><b>Reemplazo extendido</b></h4>
        </template>
        <b-card-text>
          <div class="row">
            <div class="col-md-12 mt-2 mb-2">
              <h4 class="mb-4 text-center title-card-body">
                <b>Persona que se reemplazará</b>
              </h4>
              <div class="mt-4 mb-4 col-12">
                <vue-bootstrap-typeahead
                  v-if="reemplazar.length == 0"
                  class="
                    typehead typehead-n-border typehead-relative
                    text-buscar
                  "
                  v-model="buscarRemplazar"
                  :data="listAutocompleteReemplazar"
                  :serializer="item => item.name"
                  @hit="colaboradorReemplazar = $event"
                  placeholder="Búsqueda por nombre o cédula"
                >
                  <!-- Append a button -->
                  <template slot="prepend">
                    <span class="icon icon-search1"></span>
                  </template>
                </vue-bootstrap-typeahead>
                <b-overlay
                  :show="loadingAutocomplete"
                  rounded
                  opacity="0.6"
                  spinner-variant="primary"
                  class="d-inline-block ml-4"
                >
                </b-overlay>
              </div>
              <datatable
                v-if="reemplazar.length > 0"
                :data="reemplazar"
                :columns="columns"
                class="
                  table table-hover table-borderless                  
                  table-reemplazo
                "
              >
              </datatable>
            </div>
            <div class="col-md-12 mt-2 mb-2">
              <h4 class="mb-4 text-center title-card-body">
                <b>Persona que realizará el reemplazo</b>
              </h4>
              <datatable
                :data="reemplazo"
                :columns="columnsR"
                class="
                  table table-hover table-borderless
                  table-reemplazo
                "
              ></datatable>
            </div>
            <div class="col-6 text-center mt-4">
              <label for="reportFrom">Fecha inicio:</label>
              <b-form-datepicker
                id="startDate"
                v-model="start_date"
                :max="end_date"
                class="mb-2"
              ></b-form-datepicker>
            </div>
            <div class="col-6 text-center mt-4">
              <label for="reportTo">Fecha fin:</label>
              <b-form-datepicker
                id="endDate"
                :min="start_date"
                v-model="end_date"
                class="mb-2"
              ></b-form-datepicker>
            </div>
          </div>
          <div
            class="alert alert-info alert-sm alert-info-custom mt-4"
            role="alert"
          >
            <h5>
              <span class="icon icon-info text-primary mr-2"></span>
              Recuerda que en el periodo seleccionado, la persona que realizará
              el reemplazo obtendrá el puntaje de propinas y las funcionalidades
              asignadas en la plataforma del cargo a reemplazar.
            </h5>
          </div>
        </b-card-text>
      </b-card>
    </div>
    <div class="col-md-12 mt-2 text-center">
      <button
        :disabled="this.start_date != null && this.end_date != null"
        variant=""
        class="button-primary"
        pill
        v-on:click="confirmar_reporte"
        size="lg"
        v-if="id == null"
        style="display:initial;"
      >
        <span class="cta-small">Confirmar reporte</span> <span class="icon icon-checkmark"></span>
      </button>
    </div></div>
 
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
//import Pagination from "laravel-vue-pagination";
//import serverConfig from "../../services/config";
import DeleteRow from "@/components/datatables/DeleteRow.vue";

export default {
  name: "trainingextended",
  components: {
    //Pagination,
  },
  data() {
    return {
      // Autocomplete novedades
      buscarRemplazar: "",
      buscarRemplazo: "",
      colaboradorRemplazo: null,
      novedadColaboradores: [],
      timestamp: this.$moment().format("LL"),
      runtime: null,

      validated: false,

      checkedExtended: true,
      start_date: null,
      end_date: null,
      loadingConfirmar: true,
      columns: [
        {
          label: "Nombres y apellidos",
          field: "name",
          align: "right",
          component: DeleteRow,
          headerClass: "text-right"
        },
        {
          label: "Cargo",
          field: "position.name",
          align: "left",
          headerClass: "text-left"
        },
        {
          label: "Punto de venta",
          field: "pdv",
          align: "left",
          headerClass: "text-left"
        }
      ],

      columnsR: [
        {
          label: "Nombres y apellidos",
          field: "name",
          align: "right",
          component: DeleteRow,
          headerClass: "text-right"
        },
        {
          label: "Cargo",
          field: "cargo",
          align: "left",
          headerClass: "text-left"
        },
        {
          label: "P.V. origen",
          field: "pdvOrigen",
          align: "left",
          headerClass: "text-left"
        },
        {
          label: "P.V. destino",
          field: "pdvDestino",
          align: "left",
          headerClass: "text-left"
        }
      ]
    };
  },
  beforeMount() {
    //this.loadRows();
  },
  computed: {
    ...mapState("modPayRollNews", [
      "trainingInfo",
      "training",
      "loading",
      "loading2",
      "error",
      "message"
    ]),

    ...mapState("modTrainingExtendedForm", [
      "reemplazo",
      "reemplazar",
      "loadingAutocomplete",
      "listAutocompleteReemplazar",
      "listAutocompleteReemplazo"
    ]),

    ...mapState("modTipshiftReport", ["listAutocompleteNovedad"])
  },
  methods: {
    ...mapActions("modTrainingExtendedForm", [
      "actPushTableReemplazar",
      "actGetReemplazar"
    ]),

    confirmar_reporte() {
      alert("confirmar");
    }
  },

  watch: {
    // Obtener cambios en el buscador
    buscarRemplazar: function(newVal) {
      clearTimeout(this.runtime);
      this.runtime = setTimeout(() => {
        // Buscar autocomplete
        newVal = newVal.trim();
        if (newVal.length > 0) {
          this.actGetReemplazar(newVal)
            .then(() => {})
            .catch(response => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "No se pudo seleccionar todos los registros: " + response;
            });
        }
      }, 1500);
    },

    // Obtener cambios en el buscador
    buscarRemplazo: function(newVal) {
      console.log("buscarRemplazo");
      clearTimeout(this.runtime);
      this.runtime = setTimeout(() => {
        // Buscar autocomplete
        newVal = newVal.trim();
        if (newVal.length > 0) {
          this.actGetReemplazo(newVal)
            .then(() => {})
            .catch(response => {
              this.error.flag = true;
              this.error.class = "is-invalid";
              this.error.message =
                "No se pudo seleccionar todos los registros: " + response;
            });
        }
      }, 1500);
    },

    colaboradorReemplazar: function(a) {
      // validar que no este repetido
      let nombre = a.name,
        cargo = a.position == null ? "" : a.position.name;

      nombre = nombre.toString();
      cargo = cargo.toString();

      nombre = nombre.toLowerCase();
      cargo = cargo.toLowerCase();

      nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
      cargo = cargo.charAt(0).toUpperCase() + cargo.slice(1);

      a.name = nombre;
      a.type = 2;
      a.position == null ? { id: "", name: "" } : (a.position.name = cargo);
      if (this.novedades.length == 0) {
        this.novedades.push(a);
      } else {
        let encontrado = null;
        encontrado = this.novedades.find(row => row.id === a.id);
        if (encontrado == null) {
          this.actPushTableReemplazar(a);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.trainingForm {
  
  .card {
   font-family: 'Ubuntu';
font-style: normal;
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 0px;
position: static;
background: #FFFFFF;
margin-top: 16px;
border: 1px solid #ECEFF1 !important;
box-sizing: border-box;
box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
border-radius: 12px !important;
flex: none;
order: 0;
flex-grow: 0;
order: 1px solid #C9CAFF;
/* leve */

filter: drop-shadow(0px 0px 6px rgba(110, 116, 134, 0.12));
border-radius: 8px;
  }

  .card-header {
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;
    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
 background: #ececff !important;

  }

  .title-card-body {
    width: 95%;
background: #FFFFFF;
padding-top: 0px;
padding-bottom: 0px;
  }

  .table-reemplazo > thead {
    background: #eef2fa;
    border-radius: 8px;
    padding: 0px;
    margin: 0px;
    width: 100%;
    border-radius: 8px;
  }

  .btn-confirm {
    background: #269887;
    border-radius: 100px;
  }

  .text-buscar {
    background: #ffffff;
    /* Neutral / Gray 3 */
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 8px;

    .input-group-prepend {
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .icon-search1 {
      color: #dadada;
    }

    .icon-search1::before {
      display: flex;
      align-items: center;
      justify-content: center;
      vertical-align: center;
    }
    input {
      height: 40px;
      border: 0px;
      margin-left: -10px;
    }

    ::placeholder {
      font-family: Open Sans;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #aaaaaa;
    }
  }
}
</style>
